var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeonticket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.75C1.94483 5.75 2.85097 6.12533 3.51907 6.79343C4.18717 7.46153 4.5625 8.36767 4.5625 9.3125C4.5625 10.2573 4.18717 11.1635 3.51907 11.8316C2.85097 12.4997 1.94483 12.875 1 12.875V15.25C1 15.8799 1.25022 16.484 1.69562 16.9294C2.14102 17.3748 2.74511 17.625 3.375 17.625H22.375C23.0049 17.625 23.609 17.3748 24.0544 16.9294C24.4998 16.484 24.75 15.8799 24.75 15.25V12.875C23.8052 12.875 22.899 12.4997 22.2309 11.8316C21.5628 11.1635 21.1875 10.2573 21.1875 9.3125C21.1875 8.36767 21.5628 7.46153 22.2309 6.79343C22.899 6.12533 23.8052 5.75 24.75 5.75V3.375C24.75 2.74511 24.4998 2.14102 24.0544 1.69562C23.609 1.25022 23.0049 1 22.375 1H3.375C2.74511 1 2.14102 1.25022 1.69562 1.69562C1.25022 2.14102 1 2.74511 1 3.375V5.75Z",
    stroke: "#C4F82A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0615 1V3.375",
    stroke: "#C4F82A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0615 15.25V17.625",
    stroke: "#C4F82A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0615 8.125V10.5",
    stroke: "#C4F82A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeonticket);
export default __webpack_public_path__ + "static/media/neonticket.bedb9bd61cea6fd1f16392104e7191bb.svg";
export { ForwardRef as ReactComponent };